const projectTypeMap = {
  React: "React",
  Angular: "Ng",
  "Spring Boot": "Boot",
  Flask: "Flask",
  "React + Spring Boot": ["React", "Boot"],
  "Angular + Spring Boot": ["Ng", "Boot"],
};

export default projectTypeMap;
